/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as mainMainLayoutRouteImport } from './routes/(main)/_mainLayout'
import { Route as ExperimentalExperimentalLayoutRouteImport } from './routes/experimental/_experimentalLayout'
import { Route as mainMainLayoutIndexRouteImport } from './routes/(main)/_mainLayout.index'
import { Route as ExperimentalExperimentalLayoutBwbRouteImport } from './routes/experimental/_experimentalLayout.bwb'
import { Route as ExperimentalExperimentalLayoutLawsRouteImport } from './routes/experimental/_experimentalLayout.laws'
import { Route as ExperimentalExperimentalLayoutSarRouteImport } from './routes/experimental/_experimentalLayout.sar'

const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const mainMainLayoutRoute = mainMainLayoutRouteImport.update({
  id: '/(main)/_mainLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentalExperimentalLayoutRoute =
  ExperimentalExperimentalLayoutRouteImport.update({
    id: '/experimental/_experimentalLayout',
    path: '/experimental',
    getParentRoute: () => rootRouteImport,
  } as any)
const mainMainLayoutIndexRoute = mainMainLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => mainMainLayoutRoute,
} as any)
const ExperimentalExperimentalLayoutBwbRoute =
  ExperimentalExperimentalLayoutBwbRouteImport.update({
    id: '/bwb',
    path: '/bwb',
    getParentRoute: () => ExperimentalExperimentalLayoutRoute,
  } as any)
const ExperimentalExperimentalLayoutLawsRoute =
  ExperimentalExperimentalLayoutLawsRouteImport.update({
    id: '/laws',
    path: '/laws',
    getParentRoute: () => ExperimentalExperimentalLayoutRoute,
  } as any)
const ExperimentalExperimentalLayoutSarRoute =
  ExperimentalExperimentalLayoutSarRouteImport.update({
    id: '/sar',
    path: '/sar',
    getParentRoute: () => ExperimentalExperimentalLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/experimental': typeof ExperimentalExperimentalLayoutRouteWithChildren
  '/experimental/bwb': typeof ExperimentalExperimentalLayoutBwbRoute
  '/experimental/laws': typeof ExperimentalExperimentalLayoutLawsRoute
  '/experimental/sar': typeof ExperimentalExperimentalLayoutSarRoute
  '/': typeof mainMainLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/experimental': typeof ExperimentalExperimentalLayoutRouteWithChildren
  '/experimental/bwb': typeof ExperimentalExperimentalLayoutBwbRoute
  '/experimental/laws': typeof ExperimentalExperimentalLayoutLawsRoute
  '/experimental/sar': typeof ExperimentalExperimentalLayoutSarRoute
  '/': typeof mainMainLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(main)/_mainLayout': typeof mainMainLayoutRouteWithChildren
  '/experimental/_experimentalLayout': typeof ExperimentalExperimentalLayoutRouteWithChildren
  '/experimental/_experimentalLayout/bwb': typeof ExperimentalExperimentalLayoutBwbRoute
  '/experimental/_experimentalLayout/laws': typeof ExperimentalExperimentalLayoutLawsRoute
  '/experimental/_experimentalLayout/sar': typeof ExperimentalExperimentalLayoutSarRoute
  '/(main)/_mainLayout/': typeof mainMainLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/reset-password'
    | '/experimental'
    | '/experimental/bwb'
    | '/experimental/laws'
    | '/experimental/sar'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/experimental'
    | '/experimental/bwb'
    | '/experimental/laws'
    | '/experimental/sar'
    | '/'
  id:
    | '__root__'
    | '/(auth)/login'
    | '/(auth)/reset-password'
    | '/(main)/_mainLayout'
    | '/experimental/_experimentalLayout'
    | '/experimental/_experimentalLayout/bwb'
    | '/experimental/_experimentalLayout/laws'
    | '/experimental/_experimentalLayout/sar'
    | '/(main)/_mainLayout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authLoginRoute: typeof authLoginRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  mainMainLayoutRoute: typeof mainMainLayoutRouteWithChildren
  ExperimentalExperimentalLayoutRoute: typeof ExperimentalExperimentalLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(main)/_mainLayout': {
      id: '/(main)/_mainLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof mainMainLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experimental/_experimentalLayout': {
      id: '/experimental/_experimentalLayout'
      path: '/experimental'
      fullPath: '/experimental'
      preLoaderRoute: typeof ExperimentalExperimentalLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(main)/_mainLayout/': {
      id: '/(main)/_mainLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof mainMainLayoutIndexRouteImport
      parentRoute: typeof mainMainLayoutRoute
    }
    '/experimental/_experimentalLayout/bwb': {
      id: '/experimental/_experimentalLayout/bwb'
      path: '/bwb'
      fullPath: '/experimental/bwb'
      preLoaderRoute: typeof ExperimentalExperimentalLayoutBwbRouteImport
      parentRoute: typeof ExperimentalExperimentalLayoutRoute
    }
    '/experimental/_experimentalLayout/laws': {
      id: '/experimental/_experimentalLayout/laws'
      path: '/laws'
      fullPath: '/experimental/laws'
      preLoaderRoute: typeof ExperimentalExperimentalLayoutLawsRouteImport
      parentRoute: typeof ExperimentalExperimentalLayoutRoute
    }
    '/experimental/_experimentalLayout/sar': {
      id: '/experimental/_experimentalLayout/sar'
      path: '/sar'
      fullPath: '/experimental/sar'
      preLoaderRoute: typeof ExperimentalExperimentalLayoutSarRouteImport
      parentRoute: typeof ExperimentalExperimentalLayoutRoute
    }
  }
}

interface mainMainLayoutRouteChildren {
  mainMainLayoutIndexRoute: typeof mainMainLayoutIndexRoute
}

const mainMainLayoutRouteChildren: mainMainLayoutRouteChildren = {
  mainMainLayoutIndexRoute: mainMainLayoutIndexRoute,
}

const mainMainLayoutRouteWithChildren = mainMainLayoutRoute._addFileChildren(
  mainMainLayoutRouteChildren,
)

interface ExperimentalExperimentalLayoutRouteChildren {
  ExperimentalExperimentalLayoutBwbRoute: typeof ExperimentalExperimentalLayoutBwbRoute
  ExperimentalExperimentalLayoutLawsRoute: typeof ExperimentalExperimentalLayoutLawsRoute
  ExperimentalExperimentalLayoutSarRoute: typeof ExperimentalExperimentalLayoutSarRoute
}

const ExperimentalExperimentalLayoutRouteChildren: ExperimentalExperimentalLayoutRouteChildren =
  {
    ExperimentalExperimentalLayoutBwbRoute:
      ExperimentalExperimentalLayoutBwbRoute,
    ExperimentalExperimentalLayoutLawsRoute:
      ExperimentalExperimentalLayoutLawsRoute,
    ExperimentalExperimentalLayoutSarRoute:
      ExperimentalExperimentalLayoutSarRoute,
  }

const ExperimentalExperimentalLayoutRouteWithChildren =
  ExperimentalExperimentalLayoutRoute._addFileChildren(
    ExperimentalExperimentalLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  authLoginRoute: authLoginRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  mainMainLayoutRoute: mainMainLayoutRouteWithChildren,
  ExperimentalExperimentalLayoutRoute:
    ExperimentalExperimentalLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
